module.exports = __webpack_public_path__ + "static/media/79780016-DzT0wSgs.4cbaa57d.JPG";